module.exports = "<input type=\"text\" \n\tautocomplete=\"off\" \n\tautocorrect=\"off\"\n\tautocapitalize=\"on\" \n\tspellcheck=\"false\"\n\tng-model=\"$ctrl.ngModel\" \n\tplaceholder=\"{{ $ctrl.placeholder }}\" />\n\t\n<div class=\"clear\" ng-click=\"$ctrl.clear()\" ng-class=\"{ visible: $ctrl.ngModel.length > 0 }\"><i class=\"ion-ios-close\"></i></div>\n"


//////////////////
// WEBPACK FOOTER
// ./app/components/searchInput/searchInput.html
// module id = 418
// module chunks = 0